import { render, staticRenderFns } from "./ModalPasTvarkymas.vue?vue&type=template&id=5327bd81&scoped=true&"
import script from "./ModalPasTvarkymas.vue?vue&type=script&lang=js&"
export * from "./ModalPasTvarkymas.vue?vue&type=script&lang=js&"
import style0 from "./ModalPasTvarkymas.vue?vue&type=style&index=0&id=5327bd81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5327bd81",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VCol,VDialog,VRow,VSpacer})
